var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Useful Links & Resources',
      "subTitleText": 'Looking for insights as to how to best position yourself to do business with the government? Need to know more about new and emerging cyber threats? Project Spectrum is proud to be a great resource on all those fronts, but we recognize that there are other strategic resources that can help you as you build out the security principles that govern your business. Here are some useful links and resources that can help you move forward!'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 section-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pb-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search Links and Resources..."
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1), _vm.displayedBlogItems.length === 0 && _vm.searchQuery ? _c('p', {
    staticClass: "pb-2"
  }, [_vm._v(" No items match the search criteria... ")]) : _vm._e(), _vm.displayedBlogItems.length === 0 && !_vm.searchQuery ? _c('p', {
    staticClass: "pb-2"
  }, [_vm._v(" Check back soon for blog posts... ")]) : _vm._e(), _c('div', {
    staticClass: "blog-post-grid"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.displayedBlogItems, function (item) {
    var _item$taggedCategory$;
    return _c('div', {
      key: item.id,
      staticClass: "col-12 mb-3"
    }, [_c('div', {
      staticClass: "row blog-item border d-flex"
    }, [_c('div', {
      staticClass: "col-12 p-3 useful-link-info"
    }, [_c('a', {
      staticClass: "text-dark"
    }, [_c('div', {
      staticClass: "post-event d-inline-block align-items-center pt-2"
    }, [_c('a', {
      staticClass: "blog-info-meta text-dark"
    }, [_vm._v(_vm._s((_item$taggedCategory$ = item.taggedCategory[0]) === null || _item$taggedCategory$ === void 0 ? void 0 : _item$taggedCategory$.text.toUpperCase()))])]), _c('h4', {
      staticClass: "blog-post-title mt-1"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('p', {
      staticClass: "limit-lines-3"
    }, [_vm._v(_vm._s(item.description))]), _c('a', {
      staticClass: "limit-lines-1",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.url))])])])])]);
  }), 0)]), _c('div', [_c('b-pagination', {
    attrs: {
      "id": "blog-pagination",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }